import React from 'react';
import { PhotoThumb } from './PhotoViewer';
import { parseLegacyText } from './roHelpers';

export function collectPhotoKeys(activities) {
  const keys = [];
  for (const a of activities || []) {
    const { photoKey: legacy } = parseLegacyText(a.text);
    if (legacy) keys.push(legacy);
    for (const k of a.photos || []) keys.push(k);
  }
  return keys;
}

export default function PhotosGrid({ activities, onPhotoExpand }) {
  const keys = collectPhotoKeys(activities);
  if (keys.length === 0) {
    return <div className="ro-stream-empty">No photos yet.</div>;
  }
  return (
    <div className="ro-photos-grid">
      {keys.map((k, i) => <PhotoThumb key={`${k}-${i}`} photoKey={k} onExpand={onPhotoExpand} />)}
    </div>
  );
}
